<template>
  <div class="history-list-container">
    <!-- AI助手头部 -->
    <div class="ai-header">
      <img
        :src="cdnUrl + 'ai-assets-icon.svg'"
        alt="AI助手"
        class="ai-avatar"
      />
    </div>

    <!-- 新建对话按钮 -->
    <button class="new-chat-btn" @click="handleNewChat">
      <img :src="cdnUrl + 'ai-edit-active.svg'" alt="新建对话" />
      <span>新建对话</span>
    </button>

    <!-- 历史对话标题 -->
    <div class="history-title-tab">历史对话</div>

    <!-- 历史对话列表 -->
    <div class="history-sidebar" @scroll="handleSidebarScroll">
      <div
        v-for="item in historyList"
        :key="item.id"
        class="history-item"
        :class="{
          active: selectedId === item.id,
          hover: hoveredItem === item.id,
        }"
        @click="selectHistory(item)"
        @mouseenter="hoveredItem = item.id"
        @mouseleave="hoveredItem = null"
      >
        <div class="history-item-left">
          <img class="history-icon" :src="cdnUrl + 'ai-question.svg'" alt="" />
          <span class="history-title">{{ item.title }}</span>
          <div class="history-item-actions">
            <el-popover
              placement="bottom-start"
              width="80"
              trigger="click"
              :visible-arrow="false"
              popper-class="history-delete-popover"
            >
              <button class="delete-btn" @click="handleDelete(item.id)">
                <img :src="cdnUrl + 'ai-delete.svg'" alt="删除" />
                <span>删除</span>
              </button>
              <i slot="reference" class="el-icon-more more-icon"></i>
            </el-popover>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getConversationPage, deleteConversation } from "@/api/ai/newAi.js";
export default {
  name: "HistoryList",
  props: {
    historyId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      cdnUrl: "https://cdn-image.yucrm.cn/images/tb-front-platform/images/ai/",
      selectedId: null,
      hoveredItem: null,
      historyList: [],
      currentPage: 1,
      pageSize: 40,
      isLoading: false,
      hasMore: true,
      showMoreMenu: false,
    };
  },
  computed: {
    ...mapGetters(["softwareInfo"]),
  },
  created() {
    this.getList();
  },
  methods: {
    selectHistory(item) {
      this.selectedId = item.id;
      this.$emit("select", item.id);
    },
    handleDelete(id) {
      deleteConversation(id).then((res) => {
        if(res.code == 200){
          this.$emit("delete", id);
          this.getList();
        }
      });
    },
    handleNewChat() {
      this.$emit("newChat");
    },
    getList(isLoadMore = false) {
      if (this.isLoading) return;

      const page = isLoadMore ? this.currentPage + 1 : 1;
      getConversationPage({
        platform: "TB",
        userId: this.softwareInfo.platformAccountInfo.platformCompanyUserId,
        current: page,
        size: this.pageSize,
      })
        .then((res) => {
          if (isLoadMore) {
            this.historyList = [...this.historyList, ...res.data.records];
          } else {
            this.historyList = res.data.records;
            this.currentPage = 1;
          }

          this.hasMore = res.data.records.length >= this.pageSize;
          this.currentPage = page;
          this.isLoading = false;
          if (res.data.records && res.data.records.length) {
            this.selectedId = res.data.records[0].id;
          }
          // 如果有historyId，自动选中
          if (this.historyId && !isLoadMore) {
            this.selectedId = this.historyId;
          }
          this.$emit("select", this.selectedId);
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    handleSidebarScroll(e) {
      const target = e.target;
      if (
        target.scrollTop + target.clientHeight >= target.scrollHeight - 10 &&
        this.hasMore &&
        !this.isLoading
      ) {
        this.getList(true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.history-list-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f8f9fa;
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
  width: 280px;
}

/* AI助手头部 */
.ai-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 10px 20px;
}

.ai-avatar {
  width: 120px;
  height: 50px;
}

.ai-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

/* 新建对话按钮 */
.new-chat-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-bottom: 42px;
  padding: 8px 12px;
  background-color: rgba(49, 89, 255, 0.1);
  border: 1px solid rgba(49, 89, 255, 0.3);
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #3159ff;
  transition: all 0.3s;
  margin-left: 20px;
  margin-right: 20px;
}

.new-chat-btn img {
  width: 18px;
  height: 18px;
}

/* 历史对话标题 */
.history-title-tab {
  padding: 8px 20px;
  font-size: 12px;
  color: #999999;
  font-weight: 500;
}

/* 历史对话列表 */
.history-sidebar {
  flex: 1;
  overflow-y: auto;
}

.history-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  cursor: pointer;
  border-radius: 8px;
  margin: 2px 10px;
  position: relative;
  outline: none;
}

.history-item:hover {
  background-color: #eeeef1;
}

.history-item.active {
  background-color: #fff;
  border: 1px solid #e9e9e9;
}

.history-item-left {
  display: flex;
  align-items: center;
  flex: 1;
  overflow: hidden;
}

.history-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  flex-shrink: 0;
}

.history-item-left .history-title {
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0;
  flex: 1;
}

.history-item-actions {
  display: flex;
  align-items: center;
  margin-left: 8px;
}

.more-icon {
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #999;
  font-size: 16px;
  opacity: 0;
  transition: opacity 0.2s;
}

.history-item:hover .more-icon {
  opacity: 1;
}

.delete-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 10px 16px;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #f56c6c;
  font-weight: 500;
  transition: all 0.2s ease;
}

.delete-btn:hover {
  background-color: #fff5f5;
}

.delete-btn img {
  width: 18px;
  height: 18px;
}
</style>

<style lang="scss">
.history-delete-popover {
  min-width: 120px;
  padding: 4px !important;
  border-radius: 8px !important;
}
</style>